/**
 * File: todayFiguresUtils.ts
 * Path: apps/admin/src/features/today/utils/todayFiguresUtils.ts
 * Description: The small chip under each of the two Today boxes (open pipeline, hours this week). Money is not a box
 * on Today: it is one line (TodayMoneyLine).
 */

import { hoursText, type Tone, type TodayFigures } from "@/features/today/utils/todayOverviewUtils";

export interface FigureChip {
  tone: Tone;
  text: string;
}

const arrow = (n: number) => (n >= 0 ? "▲" : "▼");

export const figureChips = (f: TodayFigures): { pipeline: FigureChip; hours: FigureChip } => {
  const weekChange = f.weekMinutes - f.lastWeekMinutes;
  return {
    pipeline:
      f.winRatePercent === null
        ? { tone: "neutral", text: `${f.openCount} open deal${f.openCount === 1 ? "" : "s"}` }
        : { tone: "neutral", text: `${f.winRatePercent}% of quotes win` },
    hours:
      f.weekMinutes === 0 && f.lastWeekMinutes === 0
        ? { tone: "neutral", text: "No time logged yet" }
        : { tone: "neutral", text: `${arrow(weekChange)} ${hoursText(Math.abs(weekChange))} on last week` },
  };
};
